import { DialogObject } from '@/components/dialog/dialog.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicField, EditorFieldProps, FieldVariant, FileFieldProps } from '@/components/form-builder/form-builder.types';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload';
import { DacRepository } from '@/store/dac-state/dac-state.repository';

interface getDACCommitteeReviewDialogProps {
  store: DacRepository;
  validate: () => void;
}

export const getDACCommitteeReviewDialog = ({ store, validate }: getDACCommitteeReviewDialogProps): DialogObject => {
  const editorField: DynamicField<EditorFieldProps> = {
    label: 'dac.form.review',
    variant: FieldVariant.EDITOR,
    isRequired: true,
    props: {
      value: store.getNested('review', 'comment'),
      onChange: (value: string) => store.setNested('review', 'comment', value),
      placeholder: 'dac.form.placeholders.comment',
      height: '200px',
    },
  };

  const fileField: DynamicField<FileFieldProps> = {
    label: '',
    variant: FieldVariant.FILE,
    props: {
      mode: 'basic',
      accept: 'application/pdf',
      multiple: true,
      value: store.getNestedObservable<File[]>('review', 'files'),
      onFileSelect: (event: FileSelectEvent) => {
        store.setNested('review', 'files', event.currentFiles);
      },
      onFileRemoved: (event: FileRemoveEvent) => {
        store.setNested(
          'review',
          'files',
          store.getNested<File[]>('review', 'files').filter(file => file.name !== event.file.name)
        );
      },
    },
  };

  return {
    title: 'dac.form.reporterReview',
    actions: [
      {
        label: 'dac.actions.validate',
        variant: 'success',
        onClick: () => validate(),
      },
    ],
    width: '50vw',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject: {
          title: '',
          description: '',
          isHeaderHidden: true,
          class: '',
          grids: [
            {
              title: '',
              isHeaderHidden: true,
              gridItems: [
                {
                  fields: [editorField],
                },
                {
                  fields: [fileField],
                },
              ],
            },
          ],
        },
      },
    },
  };
};
